import React, { useState, useEffect, useRef } from 'react';
import styles from './FontSizeInput.module.css';
import Dropdown from 'react-bootstrap/Dropdown';

const MIN_SIZE = 1;
const MAX_SIZE = 96;
const NORMAL_SIZE = 16;

const FontSizeInput = ({ onSelect, options, fontSizeValue }) => {
  const [fontSize, setFontSize] = useState(NORMAL_SIZE);
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);

  const getFontSizeValue = (value) => {
    if(value){
      const fontSizeValue = parseInt(value, 10);
      const foundOption = options.find((option) => option.value === fontSizeValue);
      return foundOption ? foundOption.label : fontSizeValue;
    } else return fontSize
  };

  const increaseValue = () => {
    if (Number(fontSize) < MAX_SIZE) {
      setFontSize(Number(fontSize) + 1);
    }
  };

  const decreaseValue = () => {
    if (Number(fontSize) > MIN_SIZE) {
      setFontSize(Number(fontSize) - 1);
    }
  };

  const onChangeInput = (e) => {
    const { value } = e.target;
    if (MIN_SIZE <= Number(value) && Number(value) < MAX_SIZE) {
      setFontSize(value);
    }
  };

  const handleSelectChange = (value) => {
    setFontSize(value);
    setShow(false);
  };

  const handleFocus = () => {
    setShow(true);
  };

  useEffect(() => {
    onSelect(fontSize);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShow(false);
        }
      };
      window.addEventListener('click', handleClickOutside);

      return () => {
        window.removeEventListener('click', handleClickOutside);
      };
  }, [fontSize]);

  return (
    <div className={styles.container} ref={dropdownRef}>
      <div className={styles.fontContainer}>
        <div className={styles.value} onClick={decreaseValue}>
          -
        </div>
        <input
          type="text"
          pattern="[0-9]*"
          value={getFontSizeValue(fontSizeValue)}
          onChange={onChangeInput}
          onFocus={handleFocus}
          className={styles.input}
          min={1}
        />
        <div className={styles.value} onClick={increaseValue}>
          +
        </div>
      </div>
      <Dropdown.Menu className={styles.dropDownMenu} show={show} >
        {options.map((option, index) => (
          <Dropdown.Item
            key={index}
            className={styles.dropdownItem}
            onClick={() => handleSelectChange(option.value)}
          >
            <div className={styles.items}>{option?.label && option.label}</div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </div>
  );
};

export default FontSizeInput;
